import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import ImpactSection from "../../components/ImpartSec/ImpartSec";

import {
  FiArrowRight,
  FiBarChart2,
  FiCheckCircle,
  FiDollarSign,
  FiMousePointer,
  FiSearch,
  FiTarget,
  FiTrendingUp,
  FiUsers,
  FiSettings,
} from "react-icons/fi";

import "./Case.css";

/* =========================================================
   BEFORE IMAGES
========================================================= */

import CS1B from "../../assets/CS1B.png";
import CS2B from "../../assets/CS2B.png";
import CS3B from "../../assets/CS3B.png";
import CS4B from "../../assets/CS4B.png";
import CS5B from "../../assets/CS5B.png";
import CS6B from "../../assets/CS6B.png";
import CS7B from "../../assets/CS7B.png";
import CS8B from "../../assets/CS8B.png";
import CS9B from "../../assets/CS9B.png";
import CS10B from "../../assets/CS10B.png";
import CS11B from "../../assets/CS11B.png";
import CS12B from "../../assets/CS12B.png";
import CS13B from "../../assets/CS13B.png";
import CS14B from "../../assets/CS14B.png";

/* =========================================================
   AFTER IMAGES
========================================================= */

import CS1A from "../../assets/CS1A.png";
import CS2A from "../../assets/CS2A.png";
import CS3A from "../../assets/CS3A.png";
import CS4A from "../../assets/CS4A.png";
import CS5A from "../../assets/CS5A.png";
import CS6A from "../../assets/CS6A.png";
import CS7A from "../../assets/CS7A.png";
import CS8A from "../../assets/CS8A.png";
import CS9A from "../../assets/CS9A.png";
import CS10A from "../../assets/CS10A.png";
import CS11A from "../../assets/CS11A.png";
import CS12A from "../../assets/CS12A.png";
import CS13A from "../../assets/CS13A.png";
import CS14A from "../../assets/CS14A.png";
import CS15 from "../../assets/CS15.png";
import CS16 from "../../assets/CS16.png";
import CS17 from "../../assets/CS17.png";
import CS18 from "../../assets/CS18.png";
import CS19 from "../../assets/CS19.png";
import CS20 from "../../assets/CS20.png";
import CS21 from "../../assets/CS21.png";
import CS22 from "../../assets/CS22.png";

import CS23 from "../../assets/CS23.png";
import CS24 from "../../assets/CS24.png";
import CS25 from "../../assets/CS25.png";
import CS26 from "../../assets/CS26.png";
import CS27 from "../../assets/CS27.png";
import CS28 from "../../assets/CS28.png";


/* =========================================================
   CASE STUDIES DATA
========================================================= */

const caseStudies = {
  /* =======================================================
     CASE STUDY 1
  ======================================================= */

  "social-security-law": {
  category: "Google Ads Case Study",

  title: "Social Security Disability Law Firm",

  result: "-59%",

  resultLabel: "Cost per lead",

  description:
    "Optimized Google Ads to increase leads while significantly reducing the cost of acquiring each potential client.",

  overview:
    "The campaign focused on generating more leads for a Social Security Disability law firm while improving advertising efficiency.",

  beforeTitle: "$118 cost per lead",

  beforeDescription:
    "The account was generating leads, but acquisition costs were high and campaign structure was limiting growth.",

  highlight:
    "Cost per conversion reduced from $118 to $47.81",

  beforeImage: CS1B,

  afterImage: CS1A,

  afterTitle: "131 leads",

  afterDescription:
    "Through campaign restructuring and high-intent keyword optimization, the account generated more leads at a much lower acquisition cost.",

  stats: [
    ["113 → 131", "Leads"],
    ["$118 → $47.81", "Cost per lead"],
    ["+16%", "Lead growth"],
    ["Improved", "Efficiency"],
    ["Higher", "Intent"],
    ["Better", "Targeting"],
  ],
},


  /* =======================================================
     CASE STUDY 2
  ======================================================= */

  "drywall-home-repair-services": {
    category: "Google Ads Case Study",

    title: "Salem Drywall & Repair Services Company",

    result: "-81%",

    resultLabel: "Cost per lead",

    description:
      "Optimized Google Ads to increase qualified leads from 18 to 149 while cutting cost per conversion from $208 to $40.22.",

    overview:
      "The objective was to help a home repair company generate a consistent flow of qualified customers through Google Ads while reducing wasted advertising spend.",

    beforeTitle: "$208 cost per conversion",

    beforeDescription:
      "The account had high acquisition costs and limited conversion volume from existing campaign targeting.",

    highlight:
      "Cost per conversion reduced from $208 to $40.22",

    beforeImage: CS2B,

    afterImage: CS2A,

    afterTitle: "149 qualified leads",

    afterDescription:
      "Campaign restructuring and stronger search intent targeting helped dramatically increase conversion volume while reducing acquisition costs.",

    stats: [
      ["18 → 149", "Conversions"],
      ["$208 → $40.22", "Cost per conversion"],
      ["+728%", "Conversion growth"],
      ["Higher", "Intent"],
      ["Better", "Targeting"],
      ["Lower", "Wasted spend"],
    ],
  },


  /* =======================================================
     CASE STUDY 3
  ======================================================= */

  "najam-al-wali-furniture": {
    category: "Google Ads Case Study",

    title: "Najam Al Wali Furniture",

    result: "+379%",

    resultLabel: "More conversions in one quarter",

    description:
      "Same account, same channel — restructured around buying intent.",

    overview:
      "Grow enquiries for a furniture retailer without letting cost per conversion climb. Two matched quarters tell the story: Jan–Mar 2026 before, Apr–Jun 2026 after.",

    beforeTitle: "Rs 178K spent for 222 conversions",

    beforeDescription:
      "1.22K clicks and 9.88K impressions — at Rs 802 per conversion, with weeks of the quarter producing nothing at all.",

    highlight:
      "Rs 802 → Rs 342 cost per conversion",

    beforeImage: CS3B,

    afterImage: CS3A,

    afterTitle: "1,060 conversions at Rs 342 each",

    afterDescription:
      "2.88K clicks and 18.8K impressions, converting at 36.8%. Spend rose by choice — each conversion now costs less than half.",

    stats: [
      ["222 → 1,060", "Conversions"],
      ["Rs 802 → 342", "Cost per conversion"],
      ["18.2% → 36.8%", "Conversion rate"],
      ["1.22K → 2.88K", "Clicks"],
      ["9.88K → 18.8K", "Impressions"],
      ["Rs 146 → 126", "Average CPC"],
    ],
  },


  /* =======================================================
     CASE STUDY 4
  ======================================================= */

  "atoz-furniture": {
    category: "Google Ads Case Study",

    title: "A to Z Used Furniture & Home Decor",

    result: "-50%",

    resultLabel: "Cost per lead",

    description:
      "Optimized Google Ads to increase qualified conversions from 443 to 1,020 while cutting cost per conversion from Rs 716 to Rs 358.",

    overview:
      "The campaign was designed to increase qualified enquiries for a used furniture and home decor business while making advertising spend more efficient.",

    beforeTitle: "Rs 716 cost per conversion",

    beforeDescription:
      "The campaign needed stronger keyword targeting and better control over low-quality search traffic.",

    highlight:
      "Cost per conversion reduced from Rs 716 to Rs 358",

    beforeImage: CS4B,

    afterImage: CS4A,

    afterTitle: "1,020 conversions",

    afterDescription:
      "Refined targeting and stronger campaign organization allowed the account to generate substantially more conversions at a lower acquisition cost.",

    stats: [
      ["443 → 1,020", "Conversions"],
      ["Rs 716 → 358", "Cost per conversion"],
      ["+130%", "Conversions"],
      ["Better", "Targeting"],
      ["Higher", "Intent"],
      ["Lower", "Acquisition cost"],
    ],
  },


  /* =======================================================
     CASE STUDY 5
  ======================================================= */

  "shah-sawood": {
    category: "Google Ads Case Study",

    title: "Shah Sawood",

    result: "-28%",

    resultLabel: "Cost per conversion",

    description:
      "Optimized Google Ads to increase qualified conversions from 317 to 1,100 while cutting cost per conversion from Rs 476 to Rs 343.",

    overview:
      "The goal was to increase the volume of qualified conversions while reducing the cost required to generate each customer action.",

    beforeTitle: "Rs 476 cost per conversion",

    beforeDescription:
      "Campaign performance needed stronger targeting, keyword refinement and budget allocation.",

    highlight:
      "Cost per conversion reduced from Rs 476 to Rs 343",

    beforeImage: CS5B,

    afterImage: CS5A,

    afterTitle: "1,100 conversions",

    afterDescription:
      "The campaign generated substantially more conversion volume while improving overall acquisition efficiency.",

    stats: [
      ["317 → 1,100", "Conversions"],
      ["Rs 476 → 343", "Cost per conversion"],
      ["+247%", "Conversions"],
      ["Better", "Bidding"],
      ["Refined", "Keywords"],
      ["Improved", "Efficiency"],
    ],
  },


  /* =======================================================
     CASE STUDY 6
  ======================================================= */

  "metro-mobile": {
    category: "Google Ads Case Study",

    title: "Metro Mobile Locksmith",

    result: "-31%",

    resultLabel: "Cost per phone call",

    description:
      "Optimized Google Ads to increase qualified phone leads from 7 to 45 while cutting cost per phone call from $118 to $81.61.",

    overview:
      "For a mobile locksmith business, phone calls are one of the most important conversion actions.",

    beforeTitle: "$118 cost per phone call",

    beforeDescription:
      "The campaign needed stronger local targeting and a greater focus on users with immediate service intent.",

    highlight:
      "Cost per phone call reduced from $118 to $81.61",

    beforeImage: CS6B,

    afterImage: CS6A,

    afterTitle: "45 qualified phone leads",

    afterDescription:
      "Location targeting, high-intent keywords and call-focused advertising helped generate significantly more qualified calls.",

    stats: [
      ["7 → 45", "Phone leads"],
      ["$118 → $81.61", "Cost per call"],
      ["+543%", "Phone leads"],
      ["High-intent", "Keywords"],
      ["Local", "Targeting"],
      ["Call-focused", "Ads"],
    ],
  },


  /* =======================================================
     CASE STUDY 7
  ======================================================= */

  "goodworth-furniture": {
    category: "Google Ads Case Study",

    title: "Goodworth Furniture",

    result: "-20%",

    resultLabel: "Cost per conversion",

    description:
      "Optimized Google Ads to increase conversions from 1,120 to 1,500 while cutting cost per conversion from Rs 448 to Rs 358.",

    overview:
      "The campaign focused on increasing furniture-related conversions while improving the overall efficiency of Google Ads spending.",

    beforeTitle: "Rs 448 cost per conversion",

    beforeDescription:
      "The account required better budget allocation and stronger focus on high-performing search traffic.",

    highlight:
      "Cost per conversion reduced from Rs 448 to Rs 358",

    beforeImage: CS7B,

    afterImage: CS7A,

    afterTitle: "1,500 conversions",

    afterDescription:
      "Budget was gradually focused toward campaigns and searches producing the strongest conversion performance.",

    stats: [
      ["1,120 → 1,500", "Conversions"],
      ["Rs 448 → 358", "Cost per conversion"],
      ["+34%", "Conversions"],
      ["Better", "Budget allocation"],
      ["Higher", "Intent"],
      ["Improved", "Efficiency"],
    ],
  },


  /* =======================================================
     CASE STUDY 8
  ======================================================= */

  "ez-phone-fix": {
    category: "Google Ads Case Study",

    title: "EZ Phone Fix",

    result: "+85%",

    resultLabel: "Phone call leads",

    description:
      "Optimized Google Ads to increase phone call leads from 166 to 307 while scaling clicks from 1.09K to 2.02K.",

    overview:
      "The objective was to increase the number of potential customers contacting the phone repair business while maintaining strong campaign relevance.",

    beforeTitle: "166 phone call leads",

    beforeDescription:
      "The campaign needed stronger high-intent repair keyword targeting and better call conversion optimization.",

    highlight:
      "Phone call leads increased from 166 to 307",

    beforeImage: CS8B,

    afterImage: CS8A,

    afterTitle: "307 phone call leads",

    afterDescription:
      "High-intent keywords, improved messaging and stronger call conversion tracking helped scale qualified phone leads.",

    stats: [
      ["166 → 307", "Phone leads"],
      ["1.09K → 2.02K", "Clicks"],
      ["+85%", "Phone leads"],
      ["High-intent", "Keywords"],
      ["Better", "Ad messaging"],
      ["Improved", "Tracking"],
    ],
  },


  /* =======================================================
     CASE STUDY 9
  ======================================================= */

  "synergy-homecare": {
    category: "Google Ads Case Study",

    title: "SYNERGY HomeCare",

    result: "+550%",

    resultLabel: "Phone call leads",

    description:
      "Optimized Google Ads to increase phone call leads from 8 to 52 while improving click-to-call rate from 6.9% to 24.5%.",

    overview:
      "The campaign needed to generate significantly more qualified phone enquiries for an in-home care service.",

    beforeTitle: "8 phone call leads",

    beforeDescription:
      "The account needed stronger service-intent targeting and a more effective click-to-call journey.",

    highlight:
      "Phone call leads increased from 8 to 52",

    beforeImage: CS9B,

    afterImage: CS9A,

    afterTitle: "52 phone call leads",

    afterDescription:
      "The campaign was continuously refined to prioritize users with strong service intent and improve the click-to-call journey.",

    stats: [
      ["8 → 52", "Phone leads"],
      ["6.9% → 24.5%", "Click-to-call"],
      ["+550%", "Phone leads"],
      ["Higher", "Service intent"],
      ["Better", "Ad messaging"],
      ["Improved", "Bidding"],
    ],
  },

  "big-city-towing": {
  category: "Google Ads Case Study",

  title: "Big City Towing",

  result: "+89%",

  resultLabel: "Phone calls",

  description:
    "Optimized Google Ads to increase phone calls from 279 to 526 while expanding search visibility and maintaining a cost per call under $8.",

  overview:
    "The campaign needed stronger search visibility and broader keyword coverage to capture more emergency towing and roadside assistance searches while increasing call volume.",

  beforeTitle: "279 phone calls",

  beforeDescription:
    "Before optimization, the campaign generated 279 phone calls from 6.36K impressions. Narrow keyword coverage, restricted delivery, and limited service-area targeting were holding back call volume and leaving available towing capacity underused.",

  highlight:
    "Phone calls increased from 279 to 526 in a single month",

  beforeImage: CS10B,

  afterImage: CS10A,

  afterTitle: "526 phone calls",

  afterDescription:
    "The campaign was optimized by expanding emergency towing and roadside assistance keywords, widening service-area targeting, enabling 24/7 ad scheduling, strengthening call assets, and scaling budget into the best-performing keywords.",

  stats: [
    ["279 → 526", "Phone calls"],
    ["6.36K → 11.7K", "Impressions"],
    ["474 → 948", "Clicks"],
    ["+89%", "Phone calls"],
    ["+74%", "Impressions"],
    ["Under $8", "Cost per call"],
  ],
},

"cosma-lab": {
category: "Google Ads Case Study",

title: "Cosma Lab",

result: "+317%",

resultLabel: "Conversions",

description:
"Optimized Google Ads to increase conversions from 102 to 425 while reducing cost per conversion from $5.43 to $2.99 and improving conversion rate from 1.04% to 9.20%.",

overview:
"The campaign was generating a high volume of clicks but very few conversions. The goal was to eliminate low-quality traffic, improve keyword intent, strengthen ad relevance, and shift the budget toward users more likely to convert.",

beforeTitle: "102 conversions",

beforeDescription:
"The campaign generated 9.78K clicks and 93.8K impressions but produced only 102 conversions, resulting in a weak 1.04% conversion rate. Broad traffic, weak intent targeting, and limited optimization were consuming budget without generating enough results.",

highlight:
"Conversions increased from 102 to 425",

beforeImage: CS11B,

afterImage: CS11A,

afterTitle: "425 conversions",

afterDescription:
"Search term audits, stronger negative keyword lists, high-intent keyword targeting, tightly themed ad groups, rewritten ads, and conversion-focused bidding helped shift spend toward traffic that was far more likely to convert.",

stats: [
["102 → 425", "Conversions"],
["1.04% → 9.20%", "Conversion rate"],
["$5.43 → $2.99", "Cost per conversion"],
["9.78K → 4.62K", "Clicks"],
["93.8K → 79K", "Impressions"],
["+317%", "Conversions"],
],
},

"dead-on-roofing": {
  category: "Google Ads Case Study",

  title: "Dead On Roofing",

  result: "+13,300%",

  resultLabel: "Phone calls",

  description:
    "Optimized Google Ads to increase phone calls from 1 to 134 while reducing average CPC from $24.79 to $13.62.",

  overview:
    "The campaign needed to generate significantly more qualified phone enquiries for a roofing business while improving the efficiency of paid search traffic.",

  beforeTitle: "1 phone call",

  beforeDescription:
    "In January, the campaign generated 46 clicks at an average CPC of $24.79, but produced only 1 phone call. The high cost per click and extremely low call volume indicated that the campaign was not generating enough valuable customer enquiries.",

  highlight:
    "Phone calls increased from 1 to 134",

  beforeImage: CS12B,

  afterImage: CS12A,

  afterTitle: "134 phone calls",

  afterDescription:
    "In February, the campaign generated 220 clicks and 134 phone calls while average CPC dropped to $13.62. The campaign produced dramatically more phone enquiries while bringing down the average cost of each click.",

  stats: [
    ["1 → 134", "Phone calls"],
    ["46 → 220", "Clicks"],
    ["$24.79 → $13.62", "Avg. CPC"],
    ["+13,300%", "Phone calls"],
    ["$1.14K → $3K", "Ad spend"],
    ["Higher", "Lead volume"],
  ],
},

"emirate-visa-services": {
  category: "Google Ads Case Study",

  title: "Emirate Visa Services",

  result: "+241%",

  resultLabel: "Conversion value",

  description:
    "Optimized Google Ads to increase conversion value from dh 227.4K to dh 774.7K while expanding reach and driving significantly more qualified visa traffic.",

  overview:
    "The campaign had strong revenue potential but inconsistent delivery, limited search reach, and insufficient keyword coverage. The goal was to expand visibility across visa markets, improve campaign structure, and shift bidding toward higher-value applications.",

  beforeTitle: "dh 227.4K conversion value",

  beforeDescription:
    "In June, ads ran for only part of the month, limiting delivery and stopping revenue generation during inactive periods. The campaign generated 9.93K clicks and 75.2K impressions but captured only a limited share of available visa search demand.",

  highlight:
    "Conversion value increased from dh 227.4K to dh 774.7K",

  beforeImage: CS13B,

  afterImage: CS13A,

  afterTitle: "dh 774.7K conversion value",

  afterDescription:
    "Keyword coverage was expanded across visa types and destination markets, campaigns were restructured into tightly themed ad groups, and relevant ads were rewritten. Value-based bidding and budget scaling helped prioritize higher-value applications while maintaining roughly 4x return on ad spend.",

  stats: [
    ["dh 227.4K → dh 774.7K", "Conversion value"],
    ["75.2K → 207K", "Impressions"],
    ["9.93K → 24.1K", "Clicks"],
    ["+241%", "Conversion value"],
    ["+175%", "Impressions"],
    ["+143%", "Clicks"],
  ],
},


"safety-training-seminars-bayareacpr": {
  category: "Google Ads Case Study",

  title: "Safety Training Seminars – BayAreaCPR",

  result: "-44%",

  resultLabel: "Cost per conversion",

  description:
    "Optimized Google Ads to cut ad spend by 44% while maintaining nearly the same conversion volume and reducing cost per conversion from $34.41 to $19.29.",

  overview:
    "The campaign was generating a high volume of conversions, but expensive clicks and broad keyword targeting were causing inefficient ad spend. The goal was to reduce wasted traffic, focus on high-intent CPR, BLS and ACLS certification searches, and maintain strong booking volume with a significantly lower budget.",

  beforeTitle: "3.11K conversions",

  beforeDescription:
    "In May, the campaign generated 23.5K clicks at an average CPC of $4.56, producing 3.11K conversions at a total cost of $107K. Broad keyword coverage was bringing in lower-quality traffic, resulting in a $34.41 cost per conversion.",

  highlight:
    "Ad spend dropped 44% while maintaining nearly the same conversion volume",

  beforeImage: CS14B,

  afterImage: CS14A,

  afterTitle: "3.09K conversions",

  afterDescription:
    "Search term audits and negative keywords reduced wasted spend, while budget was shifted toward high-intent CPR, BLS and ACLS certification keywords. Tighter campaign structures, improved ads, bids, and location targeting helped reduce costs while maintaining 3.09K conversions.",

  stats: [
    ["3.11K → 3.09K", "Conversions"],
    ["$107K → $59.6K", "Ad spend"],
    ["$34.41 → $19.29", "Cost per conversion"],
    ["$4.56 → $3.29", "Avg. CPC"],
    ["13.2% → 17.1%", "Conversion rate"],
    ["-44%", "Ad spend"],
  ],
},

"volts-electric": {

  category: "Google Ads Case Study",

  title: "Volts Electric",

  result: "94",

  resultLabel: "Phone calls",

  description:

    "Optimized Google Ads to generate 94 qualified phone calls while improving conversion tracking, restructuring campaigns, refining keyword targeting, and reducing wasted ad spend.",

  overview:

    "Volts Electric was struggling with high cost per lead, low lead volume, inaccurate conversion tracking, and an unstructured campaign setup. The goal was to improve lead quality, accurately track calls and form submissions, focus on high-intent electrical service searches, and build a sustainable campaign structure.",

  highlight:

    "Generated 94 qualified phone calls from July 1st – September 18th, 2025",

  afterTitle: "94 qualified phone calls",

  afterDescription:
    "The campaign was restructured around call volume and high-intent electrical service searches to improve quality and reduce wasted spend.",

  afterImage: CS15,

  stats: [

    ["94", "Phone calls"],

    ["919", "Clicks"],

    ["35.7K+", "Impressions"],

    ["$7.21K", "Ad spend"],

    ["Call-focused", "Campaign strategy"],

    ["High-intent", "Keyword targeting"],

  ],

},

"car-detailing": {

  category: "Google Ads Case Study",

  title: "Sprinter Car Detailing",

  result: "12.13x",

  resultLabel: "ROAS",

  description:
    "Optimized Google Ads for a San Diego car detailing company by fixing conversion tracking, building a proper landing page, targeting high-intent keywords, and shifting bidding from Maximize Clicks to Maximize Conversions to generate stronger leads and calls.",

  overview:
    "Sprinter Car Detailing was struggling with no proper landing page, inaccurate or incomplete tracking, and inconsistent leads and phone calls. We completed a full Google Ads account audit, built a proper landing page and conversion tracking setup, identified the best high-intent keywords, and initially used Maximize Clicks to gather quality traffic. Once sufficient conversion data was collected, the campaign was shifted to Maximize Conversions to improve lead generation and overall campaign performance.",

  highlight:
    "Achieved a 12.13x ROAS while generating 127 phone calls and 86.97 conversions in August 2025",

  afterTitle: "12.13x ROAS",

  afterDescription:
    "The campaign was optimized around high-intent automotive service searches, accurate conversion tracking, a dedicated landing page, and conversion-focused bidding to increase qualified leads and calls.",

  afterImage: CS16,

  stats: [

    ["12.13x", "ROAS"],

    ["127", "Phone calls"],

    ["86.97", "Conversions"],

    ["824", "Clicks"],

    ["10.4%", "Conversion rate"],

    ["Max Conversions", "Bid strategy"],

  ],

},

"plumbing-services": {
  category: "Google Ads Case Study",
  title: "XYZ Plumbing Services",
  result: "2.69x",
  resultLabel: "Cost Per Lead",
  description:
    "Optimized Google Ads for a local plumbing company by segmenting campaigns for high-intent keywords, enabling call-only ads, adding negative keywords, and adjusting bidding based on seasonal trends to maximize qualified leads and phone calls.",
  overview:
    "XYZ Plumbing Services faced seasonal drops in demand, unstable cost per lead, and low-quality clicks. We segmented campaigns around emergency plumbing searches, enabled call-only ads during business hours, added negative keywords to filter DIY traffic, and prioritized zip codes with the highest call performance. Weekly monitoring and budget scaling helped maintain steady conversions even during slower months.",
  highlight:
    "Generated 17,200 leads and 1,460 phone calls with a $46,200 total spend from Jan 2024 to Jul 2025, achieving an average cost per lead of $2.69.",
  afterTitle: "2.69x CPL Efficiency",
  afterDescription:
    "Campaign optimization focused on emergency plumbing intent, call-only ads, and seasonal bid adjustments to sustain lead volume and improve call quality.",
  afterImage: CS17,
  stats: [
    ["17,200", "Leads"],
    ["1,460", "Phone calls"],
    ["$46,200", "Total spend"],
    ["$2.69", "Avg. Cost Per Lead"],
    ["High-intent keywords", "Targeting"],
    ["Call-only ads", "Strategy"],
  ],
},

"hvac-solutions": {
  category: "Google Ads Case Study",
  title: "ABC HVAC Solutions",
  result: "2.69x",
  resultLabel: "Cost Per Lead",
  description:
    "Optimized Google Ads and Facebook campaigns for a local HVAC company by restructuring service-based campaigns, focusing on emergency keywords, and improving local visibility through Google Business Profile and LSA to generate consistent leads year-round.",
  overview:
    "ABC HVAC Solutions faced seasonal demand fluctuations, high cost per lead, and low conversion rates during off-season months. We restructured Google Ads into BOFU service campaigns, launched call-only ads for emergency HVAC searches, and implemented geo-targeted landing pages. Facebook lead gen campaigns were added for seasonal tune-up offers, while Google Business Profile and LSA optimization improved local visibility and call volume.",
  highlight:
    "Generated 1,460 conversions and 1,340 phone calls with a $29,800 total spend from Jul 2024 to Jul 2025, achieving an average cost per lead of $2.69.",
  afterTitle: "2.69x CPL Efficiency",
  afterDescription:
    "Campaign optimization focused on emergency HVAC intent, geo-targeted landing pages, and seasonal ad strategies to sustain lead volume and improve call quality.",
  afterImage: CS18,
  stats: [
    ["13.4K", "Clicks"],
    ["$29.8K", "Total Spend"],
    ["1.46K", "Conversions"],
    ["1.34K", "Phone Calls"],
    ["$2.69", "Avg. Cost Per Lead"],
    ["Call-only Ads", "Strategy"],
  ],
},

"rainy-tight-roofing": {
  category: "Google Ads Case Study",
  title: "Rainy Tight Roofing",
  result: "80%",
  resultLabel: "CPA Reduction",
  description:
    "Developed a data-driven Google Ads strategy for a U.S.-based roofing company by optimizing their website, implementing full-funnel tracking, and launching high-intent search campaigns to reduce acquisition costs and increase qualified leads.",
  overview:
    "Rainy Tight Roofing struggled with high competition, poor tracking, and inconsistent lead generation. We optimized their website for conversions, implemented click-to-call and form tracking, and launched geo-targeted Google Ads campaigns focused on high-intent roofing keywords. Continuous A/B testing of ad copies and bidding strategies helped improve performance and reduce wasted spend.",
  highlight:
    "Achieved a 130% increase in qualified leads and an 80% decrease in cost per acquisition within 30 days, generating 95 conversions from 1.91K clicks at a $21.69 cost per conversion.",
  afterTitle: "130% Lead Growth & 80% CPA Drop",
  afterDescription:
    "By combining precise tracking, high-intent keyword targeting, and conversion-focused landing pages, the campaign delivered measurable growth and cost efficiency.",
  afterImage: CS19,
  stats: [
    ["1.91K", "Clicks"],
    ["95", "Conversions"],
    ["$2.06K", "Total Spend"],
    ["$21.69", "Cost per Conversion"],
    ["130%", "Lead Increase"],
    ["80%", "CPA Reduction"],
  ],
},

"trotter-car-showroom": {
  category: "Google Ads Case Study",
  title: "Trotter Car Showroom",
  result: "110% ",
  resultLabel: "Sales Growth",
  description:
    "Implemented a full-funnel Google Ads strategy for a U.S.-based automotive parts retailer, combining Search, Shopping, and Performance Max campaigns to increase online sales and reduce acquisition costs.",
  overview:
    "Trotter Car Showroom faced high competition, poor tracking, and low ROAS in the automotive parts niche. We optimized their website for conversions, set up complete eCommerce tracking, and launched high-intent Search and Shopping campaigns. Performance Max was added to expand reach and leverage Google’s AI for smarter bidding and audience targeting. Continuous optimization of product feeds, ad creatives, and bidding strategies drove rapid improvement.",
  highlight:
    "Achieved a 110% increase in online sales and a 70% decrease in CPA within 30 days, generating 443 conversions from 4.46K clicks at a $5.9K total spend and $19.1K conversion value.",
  afterTitle: "110% Sales Growth & 70% CPA Drop",
  afterDescription:
    "By combining Search, Shopping, and Performance Max campaigns with precise tracking and conversion-focused optimization, the campaign doubled revenue while cutting acquisition costs.",
  afterImage: CS20,
  stats: [
    ["4.46K", "Clicks"],
    ["443", "Conversions"],
    ["$19.1K", "Conversion Value"],
    ["$5.9K", "Total Spend"],
    ["110%", "Sales Increase"],
    ["70%", "CPA Reduction"],
  ],
},
"ramos-furniture": {
  category: "Google Ads Case Study",
  title: "Ramos Furniture",
  result: "80%",
  resultLabel: "Sales Growth",
  description:
    "Developed a conversion-focused Google Ads strategy for a U.S.-based furniture retailer by optimizing their website, implementing advanced tracking, and launching high-performing Search, Shopping, and Performance Max campaigns to boost online sales and ROI.",
  overview:
    "Ramos Furniture faced high competition, poor tracking, and low ROAS in the furniture market. We improved their website’s speed, mobile usability, and checkout flow, implemented full-funnel tracking, and launched product-specific Search and Shopping campaigns. Performance Max was added to expand reach across Google’s network, while A/B testing of creatives and bids refined performance and reduced wasted spend.",
  highlight:
    "Achieved an 80% increase in sales and a 40% decrease in CPA within 30 days, generating $50K in conversion value from 2.03K clicks and 24.6K impressions at a $3.68K total spend.",
  afterTitle: "80% Sales Growth & 40% CPA Drop",
  afterDescription:
    "By combining Search, Shopping, and Performance Max campaigns with precise tracking and conversion-focused optimization, Ramos Furniture scaled online revenue while improving cost efficiency.",
  afterImage: CS21,
  stats: [
    ["2.03K", "Clicks"],
    ["24.6K", "Impressions"],
    ["$50K", "Conversion Value"],
    ["$3.68K", "Total Spend"],
    ["80%", "Sales Increase"],
    ["40%", "CPA Reduction"],
  ],
},

"dubai-desert-safari": {
  category: "Google Ads Case Study",
  title: "Dubai Desert Safari",
  result: "80%",
  resultLabel: "Lead Growth",
  description:
    "Built a high-performing Google Ads strategy for a UAE-based desert adventure company by optimizing their website, implementing full conversion tracking, and launching targeted Search and Local Services campaigns to increase leads and bookings.",
  overview:
    "Dubai Desert Safari faced high competition, lacked PPC presence, and had no tracking setup. We improved their website’s mobile usability and booking flow, implemented call and form tracking, and launched Search campaigns targeting high-intent keywords like 'Dubai desert safari booking.' Local Services Ads were added to capture direct calls, while ad copies and bidding strategies were optimized for lead volume and cost efficiency.",
  highlight:
    "Achieved an 80% increase in leads, a 20% decrease in CPA, and a 30% increase in bookings within the first campaign cycle, generating 6.37K conversions from 9.59K clicks at a total cost of AED 84.8K and AED 13.32 cost per conversion.",
  afterTitle: "80% Lead Growth & 30% Booking Increase",
  afterDescription:
    "Through precise keyword targeting, conversion tracking, and optimized bidding, Dubai Desert Safari scaled its online presence and improved ROI in a competitive tourism market.",
  afterImage: CS22,
  stats: [
    ["9.59K", "Clicks"],
    ["6.37K", "Conversions"],
    ["AED 13.32", "Cost per Conversion"],
    ["AED 84.8K", "Total Spend"],
    ["80%", "Lead Increase"],
    ["30%", "Booking Growth"],
  ],
},

"wizard-of-ducts": {
  category: "Google Ads Case Study",
  title: "Wizard of Ducts",
  result: "120%",
  resultLabel: "Lead Growth",
  description:
    "Implemented a high-performing Google Ads strategy for a U.S.-based air duct cleaning company by optimizing their website, setting up full conversion tracking, and launching targeted Search and Local Services campaigns to increase leads and phone calls.",
  overview:
    "Wizard of Ducts faced strong competition, lacked PPC advertising, and had no tracking setup. We optimized their website for better user experience and mobile responsiveness, implemented call and form tracking, and launched Search campaigns targeting high-intent keywords like 'air duct cleaning near me.' Local Services Ads were added to capture direct calls from local customers, while continuous optimization improved efficiency and ROI.",
  highlight:
    "Achieved a 120% increase in leads and a 15% decrease in CPA, generating 838 charged leads (588 phone leads and 250 message leads) with $58,741 total spend and 239,714 ad impressions from Jan–Dec 2024.",
  afterTitle: "120% Lead Growth & 15% CPA Drop",
  afterDescription:
    "Through precise keyword targeting, conversion tracking, and optimized bidding, Wizard of Ducts scaled its lead generation and improved cost efficiency in a competitive home services market.",
  afterImage: CS23,
  stats: [
    ["838", "Charged Leads"],
    ["588", "Phone Leads"],
    ["250", "Message Leads"],
    ["$58,741", "Total Spend"],
    ["239,714", "Ad Impressions"],
    ["120%", "Lead Increase"],
    ["15%", "CPA Reduction"],
  ],
},

"emirates-visa": {
  category: "Google Ads Case Study",
  title: "Emirates Visa",
  result: "400%",
  resultLabel: "Lead Growth",
  description:
    "Developed a data-driven Google Ads strategy for a UAE-based visa service provider by optimizing their website, implementing full tracking, and launching segmented campaigns to increase online visa applications and improve cost efficiency.",
  overview:
    "Emirates Visa faced high competition, lacked tracking, and had no structured Google Ads strategy. We optimized their website for speed and mobile usability, implemented complete conversion tracking, and launched multiple Search campaigns targeting high-intent, long-tail, and branded keywords. Campaigns were segmented by location, device, and audience type, with continuous A/B testing to refine ad copies, landing pages, and bidding strategies for maximum ROI.",
  highlight:
    "Achieved a 400% increase in leads, a 25% decrease in CPA, and a 200% increase in sales volume, generating 2.64K conversions from 121K clicks at a total cost of AED 260K and AED 98.58 cost per conversion.",
  afterTitle: "400% Lead Growth & 25% CPA Drop",
  afterDescription:
    "Through precise keyword segmentation, conversion tracking, and optimized bidding, Emirates Visa scaled its online applications and improved profitability in a competitive travel market.",
  afterImage: CS24,
  stats: [
    ["121K", "Clicks"],
    ["2.64K", "Conversions"],
    ["AED 98.58", "Cost per Conversion"],
    ["AED 260K", "Total Spend"],
    ["400%", "Lead Increase"],
    ["25%", "CPA Reduction"],
  ],
},

"charles-farris": {
  category: "Google Ads Case Study",
  title: "Charles Farris",
  result: "300%",
  resultLabel: "Sales Growth",
  description:
    "Implemented a data-driven Google Ads strategy for a luxury British candle brand by optimizing their website, setting up advanced tracking, and launching Search, Brand, and Performance Max campaigns to boost online sales and profitability.",
  overview:
    "Charles Farris faced high competition in the luxury scented candle market and lacked proper tracking and a cohesive advertising strategy. We enhanced their website for faster load times and stronger calls-to-action, implemented Google Analytics and enhanced eCommerce tracking, and launched Search and Brand campaigns to capture high-intent traffic. A Performance Max Shopping Campaign was added to expand reach across Google’s network, leveraging AI-driven optimization for maximum conversions.",
  highlight:
    "Achieved a 300% increase in sales volume and a 25% decrease in CPA, generating 8.13K purchases from 137K clicks with £83.4K total spend and 414K conversion value.",
  afterTitle: "300% Sales Growth & 25% CPA Drop",
  afterDescription:
    "By combining Search, Brand, and Performance Max campaigns with precise tracking and conversion-focused optimization, Charles Farris scaled online sales and strengthened its market position in the luxury home fragrance niche.",
  afterImage: CS25,
  stats: [
    ["137K", "Clicks"],
    ["414K", "Conversion Value"],
    ["8.13K", "Purchases/Sales"],
    ["£83.4K", "Total Spend"],
    ["300%", "Sales Increase"],
    ["25%", "CPA Reduction"],
  ],
},

"vox-city": {
  category: "Google Ads Case Study",
  title: "Vox City",
  result: "400%",
  resultLabel: "Lead Growth",
  description:
    "Implemented a structured Google Ads strategy for a UK-based tourism company by optimizing their website, setting up accurate tracking, and transitioning from Maximize Clicks to Maximize Conversions bidding to boost online bookings and profitability.",
  overview:
    "Vox City faced high competition in the UK tourism market, poor-quality leads, and high CPA. We optimized their website for faster load times and clearer calls-to-action, configured Google Analytics and Ads tracking, and launched Search campaigns using Maximize Clicks to gather data. Once sufficient conversion data was collected, we shifted to Maximize Conversions bidding, continuously refining keywords, ad copies, and landing pages to drive qualified leads and bookings.",
  highlight:
    "Achieved a 400% increase in leads, a 45% decrease in CPA, and a 300% increase in sales volume, generating 531 conversions from 16.9K clicks at an average CPC of £0.63 and 10.93% CTR.",
  afterTitle: "400% Lead Growth & 45% CPA Drop",
  afterDescription:
    "By combining Maximize Clicks and Maximize Conversions bidding strategies with precise keyword targeting and conversion tracking, Vox City scaled online bookings and improved ROI in a competitive tourism market.",
  afterImage: CS26,
  stats: [
    ["16.9K", "Clicks"],
    ["10.93%", "CTR"],
    ["£0.63", "Avg. CPC"],
    ["531", "Conversions"],
    ["400%", "Lead Increase"],
    ["45%", "CPA Reduction"],
  ],
},

"rocky-top-plumbing": {
  category: "Google Ads Case Study",
  title: "Rocky Top Plumbing & HVAC",
  result: "55%",
  resultLabel: "CPL Reduction",
  description:
    "Optimized Google Ads for a U.S.-based plumbing and HVAC company by improving landing pages, refining keywords, and implementing advanced tracking to reduce lead costs and scale daily inquiries.",
  overview:
    "Rocky Top Plumbing & HVAC struggled with high cost per lead, inconsistent daily inquiries, and irrelevant leads. We optimized their landing page for stronger CTAs and messaging, implemented Google Tag Manager and call tracking, refined keyword targeting, and revamped ad copy to attract qualified prospects. A new bidding strategy was introduced to lower costs while maintaining visibility.",
  highlight:
    "Achieved a 55% reduction in cost per lead and scaled to 20–25 leads per day, generating 2.38K conversions from 6.47K clicks at a total spend of $5.95K and 84.1K impressions.",
  afterTitle: "55% CPL Drop & 25 Leads/Day",
  afterDescription:
    "Through landing page optimization, advanced tracking, and refined keyword targeting, Rocky Top Plumbing & HVAC improved lead quality and scaled daily inquiries efficiently.",
  afterImage: CS27,
  stats: [
    ["84.1K", "Impressions"],
    ["6.47K", "Clicks"],
    ["$5.95K", "Total Spend"],
    ["2.38K", "Conversions"],
    ["55%", "CPL Reduction"],
    ["25", "Leads per Day"],
  ],
},

"mitch-wright-plumbing": {
  category: "Google Ads Case Study",
  title: "Mitch Wright Plumbing & Heating",
  result: "20",
  resultLabel: "Leads Per Day",
  description:
    "Scaled a U.S.-based plumbing and HVAC company from zero to 20 daily leads by designing a high-converting landing page, implementing advanced tracking, and launching structured Google Ads campaigns focused on efficiency and growth.",
  overview:
    "Mitch Wright Plumbing lacked a conversion-optimized landing page, tracking setup, and a structured Google Ads strategy. We built a dedicated landing page with strong CTAs and trust signals, implemented Google Tag Manager and call tracking, and launched campaigns with refined keyword targeting, compelling ad copy, and optimized bidding. Once consistent results were achieved, we scaled the budget while maintaining a low cost per lead.",
  highlight:
    "Generated over 1.03M impressions with $3.2K total spend and $1.17 cost per conversion, scaling from zero to 20 leads per day while maintaining high ROI.",
  afterTitle: "Scaled to 20 Leads/Day",
  afterDescription:
    "Through landing page optimization, advanced tracking, and structured Google Ads campaigns, Mitch Wright Plumbing achieved consistent growth and cost-efficient lead generation.",
  afterImage: CS28,
  stats: [
    ["1.03M", "Impressions"],
    ["$3.2K", "Total Spend"],
    ["$1.17", "Cost per Conversion"],
    ["20", "Leads per Day"],
    ["97.5%", "Optimization Score"],
    ["High-Intent Keywords", "Targeting"],
  ],
},


};


/* =========================================================
   CASE STUDY COMPONENT
========================================================= */

const CaseStudy = () => {
  const { slug } = useParams();

  const study = caseStudies[slug];

  const hasBefore = Boolean(study?.beforeImage || study?.beforeTitle || study?.beforeDescription);
  const afterImage = study?.afterImage || study?.image || null;
  const afterTitle = study?.afterTitle || study?.title || "Results";
  const afterDescription = study?.afterDescription || study?.description || "";

  /* =======================================================
     INVALID CASE STUDY
  ======================================================= */

  if (!study) {
    return <Navigate to="/results" replace />;
  }

  return (
    <main className="case-study-page">

      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="case-study-hero">

        <div className="case-study-container">

          <div className="hero-content">

            {/* CATEGORY */}

            <div className="case-study-category">

              <FiTarget className="category-icon" />

              <span>
                {study.category}
              </span>

            </div>


            {/* TITLE */}

            <h1>
              {study.title}
            </h1>


            {/* MAIN RESULT */}

            <h2>
              {study.result}{" "}
              <span>
                {study.resultLabel}
              </span>
            </h2>


            {/* DESCRIPTION */}

            <p className="hero-description">
              {study.description}
            </p>


            {/* HERO METRICS */}

            <div className="hero-metrics">

              <div className="hero-metric">

                <FiTrendingUp />

                <strong>
                  {study.result}
                </strong>

                <span>
                  {study.resultLabel}
                </span>

              </div>


              <div className="hero-metric">

                <FiDollarSign />

                <strong>
                  {slug === "najam-al-wali-furniture"
                    ? "−57%"
                    : "−50%"}
                </strong>

                <span>
                  Cost efficiency
                </span>

              </div>


              <div className="hero-metric">

                <FiBarChart2 />

                <strong>
                  {slug === "najam-al-wali-furniture"
                    ? "36.8%"
                    : "Improved"}
                </strong>

                <span>
                  Conversion performance
                </span>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          OVERVIEW
      ===================================================== */}

      <section className="case-study-section">

        <div className="case-study-container">

          <div className="section-heading">

            <span>
              01 — OVERVIEW
            </span>

            <h2>
              The objective
            </h2>

            <p>
              {study.overview}
            </p>

          </div>

        </div>

      </section>


      {hasBefore && (
        <section className="case-study-section before-section">

          <div className="case-study-container">

            <div className="section-heading">

              <span>
                02 — BEFORE
              </span>

              <h2>
                {study.beforeTitle}
              </h2>

              <p>
                {study.beforeDescription}
              </p>

            </div>


            {/* =================================================
                BEFORE INFO TAGS
            ================================================= */}

            <div className="info-tags">

              <div>
                <FiMousePointer />
                Ads inactive for weeks
              </div>

              <div>
                <FiTrendingUp />
                High acquisition cost
              </div>

              <div>
                <FiTarget />
                No bid strategy
              </div>

            </div>


            {/* =================================================
                BEFORE SCREENSHOT
            ================================================= */}

            <div className="screenshot-card before-image">

              <div className="screenshot-header">

                <div className="window-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>

                <span>
                  BEFORE
                </span>

              </div>


              <img
                src={study.beforeImage}
                alt={`${study.title} before campaign`}
              />

            </div>

          </div>

        </section>
      )}


      {/* =====================================================
          OUR WORK
      ===================================================== */}

      <section className="case-study-section work-section">

        <div className="case-study-container">

          <div className="section-heading">

            <span>
              03 — OUR WORK
            </span>

            <h2>
              What we changed
            </h2>

          </div>


          <div className="work-grid">

            {/* WORK 01 */}

            <div className="work-item">

              <div className="work-number">
                01
              </div>

              <FiSettings />

              <h3>
                Themed ad groups
              </h3>

              <p>
                Campaigns restructured around specific service
                categories so each search matched the right offer.
              </p>

            </div>


            {/* WORK 02 */}

            <div className="work-item">

              <div className="work-number">
                02
              </div>

              <FiSearch />

              <h3>
                High-intent keywords
              </h3>

              <p>
                Coverage expanded on ready-to-buy queries,
                with ad copy rewritten to match.
              </p>

            </div>


            {/* WORK 03 */}

            <div className="work-item">

              <div className="work-number">
                03
              </div>

              <FiDollarSign />

              <h3>
                Conversion bidding
              </h3>

              <p>
                Quality score lifted, average CPC improved,
                and bidding was optimized around conversions.
              </p>

            </div>


            {/* WORK 04 */}

            <div className="work-item">

              <div className="work-number">
                04
              </div>

              <FiCheckCircle />

              <h3>
                No downtime, no waste
              </h3>

              <p>
                Downtime ended and negative keywords were
                added to cut wasted spend.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          AFTER
      ===================================================== */}

      <section className="case-study-section after-section">

        <div className="case-study-container">

          <div className="section-heading">

            <span>
              {hasBefore ? "04 — AFTER" : "02 — AFTER"}
            </span>

            <h2>
              {hasBefore ? afterTitle : `${study.result} ${study.resultLabel}`}
            </h2>

            <p>
              {afterDescription}
            </p>

          </div>


          {/* =================================================
              AFTER STATS
          ================================================= */}

          {study.stats && (
            <div className="after-stats">

              {study.stats.map((stat, index) => (

                <div
                  className="after-stat"
                  key={index}
                >

                  <div className="after-stat-icon">

                    {index === 0 && <FiTrendingUp />}

                    {index === 1 && <FiDollarSign />}

                    {index === 2 && <FiBarChart2 />}

                    {index === 3 && <FiMousePointer />}

                    {index === 4 && <FiUsers />}

                    {index === 5 && <FiTarget />}

                  </div>


                  <strong>
                    {stat[0]}
                  </strong>

                  <span>
                    {stat[1]}
                  </span>

                </div>

              ))}

            </div>
          )}


          {/* =================================================
              AFTER SCREENSHOT
          ================================================= */}

          {afterImage && (
            <div className="screenshot-card after-image">

              <div className="screenshot-header">

                <div className="window-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>

                <span>
                  AFTER
                </span>

              </div>


              <img
                src={afterImage}
                alt={`${study.title} after campaign`}
              />

            </div>
          )}

        </div>

      </section>
      <ImpactSection/>


      {/* =====================================================
          CTA
      ===================================================== */}

      <section className="case-study-cta">

        <div className="case-study-container">

          <div className="cta-content">

            <h2>
              Want this for your store?
            </h2>

            <p>
              We'll audit your account for free and show you
              where the budget is leaking.
            </p>


            <div className="cta-buttons">

              <Link
                to="/contact"
                className="primary-cta"
              >
                Book a free audit

                <FiArrowRight />

              </Link>

            </div>

          </div>

        </div>

      </section>

    </main>
  );
};


export default CaseStudy;